export default __webpack_public_path__ + "static/media/amsterdam.63a0fce9.svg";